import React from 'react';
import type { AdobeAnalyticsUser } from '../../../lib/util/adobeAnalytics';
import {
  buildAdobePageData,
  getAdobeDataLayerScript,
  getAdobePageLoadScript,
  isAdobeAnalyticsEnabled,
} from '../../../lib/util/adobeAnalytics';
import AdobeAnalyticsInitialPageTracker from './AdobeAnalyticsInitialPageTracker';

type Props = {
  pathname?: string | null;
  asPath?: string | null;
  user?: AdobeAnalyticsUser | null;
};

/**
 * Renders page-specific Adobe data-layer scripts and initial page tracking.
 */
const AdobeAnalyticsScript = ({ pathname = '', asPath = '', user }: Props) => {
  if (!isAdobeAnalyticsEnabled()) return null;

  const pageData = buildAdobePageData({ pathname, asPath, user });

  return (
    <>
      <script
        id="adobeAnalyticsDataLayer"
        dangerouslySetInnerHTML={{
          __html: getAdobeDataLayerScript(pageData),
        }}
      />
      <script
        id="adobeAnalyticsPageLoad"
        dangerouslySetInnerHTML={{
          __html: getAdobePageLoadScript(),
        }}
      />
      <AdobeAnalyticsInitialPageTracker
        initialAsPath={asPath}
        initialPathname={pathname}
        user={user}
      />
    </>
  );
};

export default AdobeAnalyticsScript;
